import { Button, Popconfirm, Tooltip } from 'antd';
import { FormInstance } from 'antd/lib';
import { MutableRefObject } from 'react';
import { useTranslation } from 'translations/hooks';

import { RepairFormValues } from 'business/quality-control/pages/record-segment-defect/components/right-panel/ring-details/defect-detail/repair-form/types';

import styles from './index.module.scss';

export const RepairFormButtons = ({
  form,
  formActionRef,
  isRingCompliant,
  isValidated,
  canEditRepair,
  canInvalidateRepair,
  onInvalidate,
}: {
  form: FormInstance<RepairFormValues>;
  formActionRef: MutableRefObject<'save' | 'submit'>;
  isRingCompliant: boolean;
  isValidated: boolean;
  canEditRepair: boolean;
  canInvalidateRepair: boolean;
  onInvalidate: () => void;
}) => {
  const { t } = useTranslation();

  if (!isValidated && canEditRepair) {
    return (
      <div className={styles.buttonsFooter}>
        <Button
          type="primary"
          onClick={() => {
            formActionRef.current = 'submit';
            form.submit();
          }}
        >
          {t(
            'qualityControl.recordSegmentDefect.rightPanel.repairform.cta.submit',
          )}
        </Button>
        <Button
          onClick={() => {
            formActionRef.current = 'save';
            form.submit();
          }}
        >
          {t(
            'qualityControl.recordSegmentDefect.rightPanel.repairform.cta.save',
          )}
        </Button>
      </div>
    );
  }

  if (!isValidated || !canInvalidateRepair) {
    return null;
  }

  return (
    <div className={styles.buttonsFooter}>
      <Tooltip
        title={
          isRingCompliant
            ? t(
                'qualityControl.recordSegmentDefect.rightPanel.repairform.invalidate.disabledTooltip',
              )
            : undefined
        }
      >
        <span className={styles.invalidateTooltipWrapper}>
          <Popconfirm
            title={t(
              'qualityControl.recordSegmentDefect.rightPanel.repairform.invalidate.title',
            )}
            onConfirm={onInvalidate}
          >
            <Button danger block disabled={isRingCompliant}>
              {t(
                'qualityControl.recordSegmentDefect.rightPanel.repairform.cta.invalidate',
              )}
            </Button>
          </Popconfirm>
        </span>
      </Tooltip>
    </div>
  );
};
